import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";

import axios from "@/configs/axios";
import { KB_SOURCE } from "@/util/constants";
import { TeamsFile } from "@/util/interfaces/TeamsFile";

export const useGetFilesFromChannel = (
  {
    drive_id,
    item_id,
  }: {
    drive_id: string;
    item_id: string;
  },
  loginRequestForBackend: any
) => {
  const { instance, accounts } = useMsal();

  return useQuery<TeamsFile[], Error>({
    queryKey: [
      "/getFilesFromChannel",
      loginRequestForBackend,
      KB_SOURCE,
      accounts[0],
      accounts[0]?.homeAccountId,
      drive_id,
      item_id,
    ],
    enabled: !!accounts[0] && !!drive_id && !!item_id,
    queryFn: async () => {
      const response = await instance.acquireTokenSilent({
        ...loginRequestForBackend,
        account: accounts[0],
      });
      const url = `${process.env.REACT_APP_SERVER_HOST}/teams-sync/drives/${drive_id}/items/${item_id}/files`;
      const { data } = await axios.get(url, {
        headers: {
          oboToken: `${response.accessToken}`,
        },
      });

      return data
        .filter((document: TeamsFile) => {
          if (document?.folder?.childCount === 0) {
            return false; // Exclude empty folders
          }
          return true; // Include files and non-empty folders
        })
        .map((document: TeamsFile) => ({
          ...document,
          channel: { drive_id, item_id },
          explored: !document?.folder,
          metadata: "",
          category: null,
          selected: false,
        })) as TeamsFile[];
    },
  });
};
